interface MusicIconProps extends React.ComponentPropsWithRef<'svg'> {
  color?: string;
}

export function MusicIcon({ color = 'currentColor', ...svgProps }: MusicIconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M12 24.4999C12 26.4329 10.2091 27.9999 8 27.9999C5.79086 27.9999 4 26.4329 4 24.4999C4 22.5669 5.79086 20.9999 8 20.9999C10.2091 20.9999 12 22.5669 12 24.4999ZM12 24.4999V9.07934C12 8.13816 12.6076 7.30462 13.5036 7.01661L23.1703 3.90947C24.5689 3.45991 26 4.50311 26 5.9722V20.4999M26 20.4999C26 22.4329 24.2091 23.9999 22 23.9999C19.7909 23.9999 18 22.4329 18 20.4999C18 18.5669 19.7909 16.9999 22 16.9999C24.2091 16.9999 26 18.5669 26 20.4999Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
